// lib/socialLinks.js
// Auto-detect social platform from URL and return icon/label/color

const PLATFORMS = [
  {
    key: 'linkedin',
    label: 'LinkedIn',
    match: (url) => /linkedin\.com/i.test(url),
    color: 'blue',
    icon: `<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>`,
    fill: true,
  },
  {
    key: 'instagram',
    label: 'Instagram',
    match: (url) => /instagram\.com/i.test(url),
    color: 'pink',
    icon: `<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>`,
    fill: true,
  },
  {
    key: 'facebook',
    label: 'Facebook',
    match: (url) => /facebook\.com|fb\.com/i.test(url),
    color: 'blue',
    icon: `<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>`,
    fill: true,
  },
  {
    key: 'twitter',
    label: 'X (Twitter)',
    match: (url) => /twitter\.com|x\.com/i.test(url),
    color: 'gray',
    icon: `<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>`,
    fill: true,
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    match: (url) => /tiktok\.com/i.test(url),
    color: 'gray',
    icon: `<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>`,
    fill: true,
  },
  {
    key: 'youtube',
    label: 'YouTube',
    match: (url) => /youtube\.com|youtu\.be/i.test(url),
    color: 'red',
    icon: `<path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>`,
    fill: true,
  },
  {
    key: 'github',
    label: 'GitHub',
    match: (url) => /github\.com/i.test(url),
    color: 'gray',
    icon: `<path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>`,
    fill: true,
  },
  {
    key: 'snapchat',
    label: 'Snapchat',
    match: (url) => /snapchat\.com/i.test(url),
    color: 'yellow',
    icon: `<path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/>`,
    fill: true,
  },
  {
    key: 'onlyfans',
    label: 'OnlyFans',
    match: (url) => /onlyfans\.com/i.test(url),
    color: 'sky',
    icon: `<path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 18.6a6.6 6.6 0 110-13.2 6.6 6.6 0 010 13.2zm0-10.2a3.6 3.6 0 100 7.2 3.6 3.6 0 000-7.2z"/>`,
    fill: true,
  },
  {
    key: 'twitch',
    label: 'Twitch',
    match: (url) => /twitch\.tv/i.test(url),
    color: 'purple',
    icon: `<path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z"/>`,
    fill: true,
  },
  {
    key: 'discord',
    label: 'Discord',
    match: (url) => /discord\.com|discord\.gg/i.test(url),
    color: 'indigo',
    icon: `<path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189z"/>`,
    fill: true,
  },
];

// Color mappings for Tailwind classes
const COLOR_MAP = {
  blue:   { bg: 'bg-blue-100 dark:bg-blue-900/40', text: 'text-blue-600 dark:text-blue-400', hover: 'hover:bg-blue-50 dark:hover:bg-blue-900/20', hoverText: 'group-hover:text-blue-600' },
  pink:   { bg: 'bg-pink-100 dark:bg-pink-900/40', text: 'text-pink-600 dark:text-pink-400', hover: 'hover:bg-pink-50 dark:hover:bg-pink-900/20', hoverText: 'group-hover:text-pink-600' },
  gray:   { bg: 'bg-gray-200 dark:bg-gray-700/60', text: 'text-gray-700 dark:text-gray-300', hover: 'hover:bg-gray-100 dark:hover:bg-gray-700/40', hoverText: 'group-hover:text-gray-700' },
  red:    { bg: 'bg-red-100 dark:bg-red-900/40', text: 'text-red-600 dark:text-red-400', hover: 'hover:bg-red-50 dark:hover:bg-red-900/20', hoverText: 'group-hover:text-red-600' },
  yellow: { bg: 'bg-yellow-100 dark:bg-yellow-900/40', text: 'text-yellow-600 dark:text-yellow-400', hover: 'hover:bg-yellow-50 dark:hover:bg-yellow-900/20', hoverText: 'group-hover:text-yellow-600' },
  sky:    { bg: 'bg-sky-100 dark:bg-sky-900/40', text: 'text-sky-600 dark:text-sky-400', hover: 'hover:bg-sky-50 dark:hover:bg-sky-900/20', hoverText: 'group-hover:text-sky-600' },
  purple: { bg: 'bg-purple-100 dark:bg-purple-900/40', text: 'text-purple-600 dark:text-purple-400', hover: 'hover:bg-purple-50 dark:hover:bg-purple-900/20', hoverText: 'group-hover:text-purple-600' },
  indigo: { bg: 'bg-indigo-100 dark:bg-indigo-900/40', text: 'text-indigo-600 dark:text-indigo-400', hover: 'hover:bg-indigo-50 dark:hover:bg-indigo-900/20', hoverText: 'group-hover:text-indigo-600' },
  emerald:{ bg: 'bg-emerald-100 dark:bg-emerald-900/40', text: 'text-emerald-600 dark:text-emerald-400', hover: 'hover:bg-emerald-50 dark:hover:bg-emerald-900/20', hoverText: 'group-hover:text-emerald-600' },
};

const WEBSITE_FALLBACK = {
  key: 'website',
  label: 'Website',
  color: 'emerald',
  icon: `<circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>`,
  fill: false,
};

/**
 * Detect social platform from a URL
 * @param {string} url
 * @returns {{ key: string, label: string, color: string, icon: string, fill: boolean, colors: object }}
 */
export function detectPlatform(url) {
  if (!url) return null;
  const normalized = url.toLowerCase().trim();
  const platform = PLATFORMS.find((p) => p.match(normalized));
  const result = platform || WEBSITE_FALLBACK;
  return {
    key: result.key,
    label: result.label,
    icon: result.icon,
    fill: result.fill,
    colors: COLOR_MAP[result.color] || COLOR_MAP.emerald,
  };
}

/**
 * Ensure URL has protocol prefix
 * @param {string} url
 * @returns {string}
 */
export function ensureProtocol(url) {
  if (!url) return '';
  return url.startsWith('http') ? url : `https://${url}`;
}

/**
 * Extract display name from URL (remove protocol + www)
 * @param {string} url
 * @returns {string}
 */
export function formatDisplayUrl(url) {
  if (!url) return '';
  return url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
}

/**
 * Merge legacy link fields (linkedInUrl, websiteUrl, portfolioUrl) with socialLinks array.
 * Deduplicates by domain.
 * @param {object} expert
 * @returns {string[]}
 */
export function getSocialLinks(expert) {
  if (!expert) return [];
  const links = [];

  // Add socialLinks array first
  if (Array.isArray(expert.socialLinks)) {
    links.push(...expert.socialLinks.filter(Boolean));
  }

  // Add legacy fields if not already present
  const legacy = [expert.linkedInUrl, expert.websiteUrl, expert.portfolioUrl].filter(Boolean);
  for (const url of legacy) {
    const normalized = url.toLowerCase().replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
    const alreadyExists = links.some(
      (existing) => existing.toLowerCase().replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '') === normalized
    );
    if (!alreadyExists) {
      links.push(url);
    }
  }

  return links;
}

/** List of supported platforms for the edit form dropdown */
export const SUPPORTED_PLATFORMS = PLATFORMS.map((p) => ({ key: p.key, label: p.label }));
